module.exports = __webpack_public_path__ + "static/word_formats-68a44b57051bff1aeb845d3c290e96f1.png";